import { sendMessage } from './chromeMessaging';
import * as actions from '../constants/actions';

const chromeStorageMiddleware = sendMessage => appId => reduxStore => next => action => {
	if (action.type === actions.APP_INIT) {
		sendMessage(appId, 'settings.get', 'sitecode')
			.then(sitecode => {
				if (sitecode) {
					reduxStore.dispatch({ type: actions.APP_LOADED_SITECODE, payload: sitecode });
				}
			})
			.catch(err => {
				const errorMessage = err || 'Failed to get sitecode';
				console.error(errorMessage);
			});
	} 
	next(action);
};

export default chromeStorageMiddleware(sendMessage);



// WEBPACK FOOTER //
// ./src/services/chromeStorageMiddleware.js